// import { Address } from "@multiversx/sdk-core";

export function hex_to_ascii(str1: number): string {
  let hex = str1.toString()
  let str = ''
  for (let n = 0; n < hex.length; n += 2) {
    str += String.fromCharCode(parseInt(hex.substr(n, 2), 16))
  }
  return str
}

export function base64ToBase16(base64: string): string {
  return window
    .atob(base64)
    .split('')
    .map(function (aChar) {
      return ('0' + aChar.charCodeAt(0).toString(16)).slice(-2)
    })
    .join('')
    .toUpperCase() // Per your example output
}

// export function poolDataDecoder(data) {
//   const address = new Address(data.slice(0, 64)).bech32();
//   data = data.slice(64);

//   const owner = new Address(data.slice(0, 64)).bech32();
//   data = data.slice(64);

//   let n = data.slice(0, 8);

//   data = data.slice(8);
//   const total_staked = Number(
//     BigInt(h2d(data.slice(0, parseInt(n, 16) * 2))) /
//       BigInt(1000000000000000000)
//   );
//   data = data.slice(parseInt(n, 16) * 2);

//   const zoidsters = parseInt(data.slice(0, 8), 16);
//   data = data.slice(8);

//   n = data.slice(0, 8);
//   data = data.slice(8);

//   const name = hex_to_ascii(data.slice(0, parseInt(n, 16) * 2), 16);
//   data = data.slice(parseInt(n, 16) * 2);

//   const status = parseInt(data, 16);

//   const pool = {
//     address,
//     owner,
//     total_staked,
//     zoidsters,
//     name,
//     status,
//   };

//   return pool;
// }

// export function stakeDataDecoder(data) {
//   const pool_id = new Address(data.slice(0, 64)).bech32();
//   data = data.slice(64);

//   let n = data.slice(0, 8);
//   data = data.slice(8);
//   const staked_amount = Number(
//     BigInt(h2d(data.slice(0, parseInt(n, 16) * 2))) /
//       BigInt(1000000000000000000)
//   );
//   data = data.slice(parseInt(n, 16) * 2);

//   const timestamp = parseInt(data.slice(0, 16), 16);
//   data = data.slice(16);

//   const created_at = new Date(timestamp * 1000);

//   const months = parseInt(data.slice(0, 4), 16);
//   data = data.slice(4);

//   const is_pool = parseInt(data.slice(0, 2), 16);
//   data = data.slice(2);

//   const address = new Address(data).bech32();

//   const stake = {
//     pool_id,
//     staked_amount,
//     timestamp,
//     created_at,
//     months,
//     is_pool,
//     address,
//   };

//   return stake;
// }

// export function rewardsDataDecoder(data) {
//   data = data.map((d) => base64ToBase16(d));

//   const numsPerGroup = Math.ceil(data.length / 4);
//   // Create array based on number of groups
//   const result = new Array(numsPerGroup)
//     // Make sure each element isn't empty
//     .fill("")
//     // For each group, grab the right `slice` of the input array
//     .map((_, i) => data.slice(i * 4, (i + 1) * 4));

//   const staking_rewards = result.map((x) => ({
//     pool_id: x[0],
//     stake_timestamp: h2d(x[1]),
//     rewards: h2d(x[2]) / 1000000000000000000,
//     expired: !!+h2d(x[3]),
//   }));

//   return staking_rewards;
// }

export function h2d(s: string): string {
  function add(a: string, b: string) {
    let c = 0,
      r = []
    const x = a.split('').map(Number)
    const y = b.split('').map(Number)
    while (x.length || y.length) {
      const s = (x.pop() || 0) + (y.pop() || 0) + c
      r.unshift(s < 10 ? s : s - 10)
      c = s < 10 ? 0 : 1
    }
    if (c) {
      r.unshift(c)
    }
    return r.join('')
  }
  let dec = '0'
  s.split('').forEach(function (chr) {
    let n = parseInt(chr, 16)
    for (let t = 8; t; t >>= 1) {
      dec = add(dec, dec)
      if (n & t) {
        dec = add(dec, '1')
      }
    }
  })
  return dec
}

// export function lastClaimsDataDecoder(data) {
//   data = data.map((d) => base64ToBase16(d));
//   let lastStakes = [];
//   for (let i = 0; i < data.length; i += 2) {
//     const chunk = data.slice(i, i + 2);
//     let pool_id = new Address(chunk[0]).bech32();
//     let timestamp = h2d(chunk[1]);
//     lastStakes.push({ pool_id, timestamp });
//   }
//   return lastStakes;
// }

export function strToHex(str: string): string {
  let result = ''
  for (let i = 0; i < str.length; i++) {
    result += str.charCodeAt(i).toString(16)
  }
  return result.length % 2 === 1 ? '0' + result : result
}

export function intToHex(number: number): string {
  const hex = number.toString(16)
  return hex.length % 2 === 1 ? '0' + hex : hex
}

export function prefixedIntToHex(number: number): string {
  const hex = number.toString(16)
  return '0x' + hex
}
